module.exports = __webpack_public_path__ + "static/media/EnCORE_consent_FR_p1.ae74b9a0.jpg";